import React, { useCallback, useMemo } from 'react'
import VerticalGroup from '../../../atoms/verticalgroup/VerticalGroup'
import SimulationSetting from './SimutationSetting'
import Text from '../../../atoms/text/Text'
import Dropdown from '../../../atoms/form/input/Dropdown'
import InlineGroup from '../../../atoms/inlinegroup/InlineGroup'
import useAssessments from '../../../../hooks/useAssessments'
import Button from '../../../atoms/button/Button'
import { Link } from 'react-router-dom'

interface Props {
  assessmentId?: string
  clientId?: string
  readOnly?: boolean
  state?: string
  onChange?: (assessment: API.AssessmentResponse | null) => void
}

interface SelectValue {
  id: string
  value: string
  label: string
  assessment: API.AssessmentResponse
}

const SelectAssessment: React.FC<Props> = ({ clientId, assessmentId, onChange, readOnly = false }) => {
  const onClearSelection = useCallback(() => {
    onChange && onChange(null)
  }, [onChange])

  const onChangeCallback = useCallback((selected: SelectValue) => {
    onChange && onChange(selected.assessment)
  }, [onChange])

  const clientIds = useMemo(() => clientId ? [clientId] : [], [clientId])

  const { data } = useAssessments(clientIds)

  const options: SelectValue[] = useMemo(() => {
    return data ? data.map(assessment => ({
      id: assessment.id,
      value: assessment.id,
      label: assessment.name,
      assessment,
    })) : []
  }, [data])

  const currentSelected = useMemo(() => {
    if (assessmentId) {
      return options.find(option => option.id === assessmentId)
    }
    return null
  }, [assessmentId, options])

  return <SimulationSetting icon='assessments' onTrashClick={onClearSelection} readOnly={readOnly}>
    <InlineGroup stretch>
      <VerticalGroup spaceBetweenElements={2}>
        <Text size="sm" bold>Assessments</Text>

        {readOnly && currentSelected && assessmentId &&
        <>
          <InlineGroup spaceLeft={2}>
            <Text size="sm">Assessment Selected: </Text>
            <Text size="sm" bold >{currentSelected?.label}</Text>
          </InlineGroup>
          <Button link>
            <Link to={`view/assessments/${assessmentId}/responses`}>Mark assessments</Link>
          </Button>
        </>
        }
        {readOnly && !currentSelected &&
          <InlineGroup spaceLeft={2}>
            <Text size="sm" colour='danger' bold>No Assessment Selected</Text>
          </InlineGroup>
        }
        {!readOnly && <Dropdown
          selectProps={{
            isDisabled: !clientId,
            onChange: onChangeCallback,
            value: currentSelected,
            options,
            noOptionsMessage: () => 'No Published Assessment'
          }}
        />}
      </VerticalGroup>
    </InlineGroup>
  </SimulationSetting>
}

export default SelectAssessment
